import { DevicePhoneMobileIcon, GiftIcon } from "@heroicons/react/24/outline"
import { useState, useEffect } from "react"
import { useLocation } from "react-router-dom";

export function Offer() {
    const [showRefer, setShowRefer] = useState<boolean>(false)
    const location = useLocation();
    
    useEffect(() => {
        // Check if we're on the settings page
        // Using useLocation hook from react-router-dom
        const isSettingsPage = location.pathname.includes('/settings');
        
        // If on settings page, always show refer; otherwise use random
        setShowRefer(isSettingsPage || Math.random() >= 0.5)
    }, [location])
    
    return (<>
        {!showRefer ? <a className='py-2 rounded-md items-center flex flex-row text-white font-semibold gap-x-3 bg-[#0066ff] text-center ring ring-[#56ffd6]  text-sm hover:ring-4 transition-all duration-300 hover:shadow-lg hover:shadow-[#56ffd6]/50 justify-center' href='https://help.vetrec.io/en/collections/10367770-downloads' target='_blank' rel="noreferrer">
            <DevicePhoneMobileIcon className='h-6 w-6' />
            Download Mobile Apps
        </a> :
            <a href='https://forms.office.com/Pages/ResponsePage.aspx?id=3X0tE5ck0UW5oxKvkzeRVw7YFQP8NXpLlBwTZHDmQEZUQzFaUkFaTUdGOFExTFhINzlNR0kzNzU1RC4u' className='py-2 rounded-md items-center flex flex-row text-white font-semibold gap-x-3 bg-[#0066ff] text-center ring ring-[#56ffd6]  text-sm hover:ring-4 transition-all duration-300 hover:shadow-lg hover:shadow-[#56ffd6]/50 justify-center' target='_blank' rel="noreferrer">
                <GiftIcon className='h-6 w-6' />
                Refer and Earn $$
            </a>}
    </>)
}